

type BackgroundColorOptions = 'none' | 'dark';

import RideitPassengerToken, { RideitPassengerTokenStatus } from "@/models/Rideit/RideitPassengerToken";
import { Component, Prop, Vue } from "vue-property-decorator";
import DateHelper from "@/util/DateHelper";
import { RolePermission } from '@/models/Role'; 
import moment from 'moment';

@Component({
  components: {},
})
export default class RideitPassengerTokenCard extends Vue {
  @Prop({ required: true }) private token: RideitPassengerToken;
  @Prop({ default: 'dark'}) private backgroundColor: BackgroundColorOptions;
  @Prop({ default: false}) private disabled: boolean;

  dateHelper = new DateHelper();

  cancelToken() {
    if (confirm(this.$t('rideIt.tokens.cancelConfirmation'))) {
      this.$emit('cancel-token', this.token);
    }
  }


  get tokenStatusText() {
    return this.$t(`rideIt.token_status.${this.token.status}`);
  }

  get tokenStatusColor() {
    if (this.token.status === RideitPassengerTokenStatus.Active) {
      return '';
    }
    return 'error--text';
  }

  get allowActions() {
    const hasPermission = this.$store.getters['auth/hasRideitPermission'](
      this.token.passenger.movitId, 
      [ RolePermission.WriteRideitTokens]
    );

    const isActive = this.token.status === RideitPassengerTokenStatus.Active;

    return hasPermission && isActive;
  }
}
